export default "__VITE_PUBLIC_ASSET__0731c37a__"